// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3akiB","buttons":"RemoveExpirationActionButtons_buttons__3meR6"};